import React, { useState } from "react";
import { Button } from "../../../components/ui/button"; // Importing Button from the specified location
import { Input } from "../../../components/ui/input"; // Importing Input from shadcn/ui
import { loginUser } from "../api/loginUser";
import storage from "../../../utils/storage";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material"; // Import IconButton from Material-UI
import { Visibility, VisibilityOff } from "@mui/icons-material"; // Import eye icons

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Track password visibility
  const navigate = useNavigate();

  // Handle Login
  const handleLogin = async () => {
    try {
      const response = await loginUser({ username, password });
      if (response) {
        storage.setToken(response.token);
        window.location.reload();
      } else {
        setError("Invalid username or password.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Error occurred while logging in.");
    }
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "auto",
        padding: "16px",
        marginTop: "10px",
        direction: "rtl", // Apply right-to-left direction
      }}
    >
      <h6 style={{ marginBottom: "16px" }}>تسجيل الدخول</h6>

      <div style={{ marginBottom: "16px" }}>
        <span>أدخل اسم المستخدم</span>
        <Input
          placeholder="اسم المستخدم"
          value={username}
          onChange={(e: any) => setUsername(e.target.value)}
          style={{ marginTop: "8px" }}
        />
      </div>

      <div style={{ marginBottom: "16px" }}>
        <span>أدخل كلمة المرور</span>
        <div style={{ position: "relative" }}>
          <Input
            placeholder="كلمة المرور"
            type={showPassword ? "text" : "password"} // Toggle password visibility
            value={password}
            onChange={(e: any) => setPassword(e.target.value)}
            style={{ marginTop: "8px", paddingRight: "40px" }} // Add padding for the icon
          />
          <IconButton
            onClick={togglePasswordVisibility}
            edge="end"
            style={{
              position: "absolute",
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </div>
      </div>

      <Button
        onClick={handleLogin}
        disabled={!username || !password}
        style={{ width: "100%", marginBottom: "16px" }}
      >
        تسجيل الدخول
      </Button>

      {error && (
        <span style={{ color: "red", marginTop: "16px", display: "block" }}>
          {error}
        </span>
      )}
    </div>
  );
};

export default LoginPage;
